// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITransactionTagDto } from './ITransactionTagDto';
import {
    ITransactionTagDtoFromJSON,
    ITransactionTagDtoFromJSONTyped,
    ITransactionTagDtoToJSON,
    ITransactionTagDtoToJSONTyped,
} from './ITransactionTagDto';
import type { IPostingDto } from './IPostingDto';
import {
    IPostingDtoFromJSON,
    IPostingDtoFromJSONTyped,
    IPostingDtoToJSON,
    IPostingDtoToJSONTyped,
} from './IPostingDto';

/**
 * 
 * @export
 * @interface ITransactionDto
 */
export interface ITransactionDto {
    /**
     * 
     * @type {number}
     * @memberof ITransactionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITransactionDto
     */
    memo?: string;
    /**
     * 
     * @type {Set<IPostingDto>}
     * @memberof ITransactionDto
     */
    postings?: Set<IPostingDto>;
    /**
     * 
     * @type {Set<ITransactionTagDto>}
     * @memberof ITransactionDto
     */
    tags?: Set<ITransactionTagDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ITransactionDto
     */
    force?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ITransactionDto
     */
    type?: ITransactionDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ITransactionDto
     */
    metadata?: string;
    /**
     * 
     * @type {Date}
     * @memberof ITransactionDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ITransactionDto
     */
    transaction_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof ITransactionDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ITransactionDto
     */
    ignore_account_status_validation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ITransactionDto
     */
    workflow_id?: string;
}

/**
* @export
* @enum {string}
*/
export enum ITransactionDtoTypeEnum {
    NOTIONAL_FUND = 'NOTIONAL_FUND',
    REPLENISHMENT_PAYMENT = 'REPLENISHMENT_PAYMENT',
    REPLENISHMENT = 'REPLENISHMENT',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    CARD_SETTLEMENT = 'CARD_SETTLEMENT',
    PAY_CLAIM = 'PAY_CLAIM',
    CHECK_CLEARED = 'CHECK_CLEARED',
    CARD_PROCESSOR_PAYMENT = 'CARD_PROCESSOR_PAYMENT',
    RECORD_KEEPING_PAYROLL = 'RECORD_KEEPING_PAYROLL',
    CONTRIBUTION_PAYMENT = 'CONTRIBUTION_PAYMENT',
    PAYROLL = 'PAYROLL',
    EMPLOYER_PAYMENT = 'EMPLOYER_PAYMENT',
    PAYMENT = 'PAYMENT',
    INTEREST = 'INTEREST',
    FEE = 'FEE',
    TRANSFER_OF_ASSETS = 'TRANSFER_OF_ASSETS',
    INVESTMENT = 'INVESTMENT',
    ACH_CLEARED = 'ACH_CLEARED',
    DEBIT_CLEARED = 'DEBIT_CLEARED',
    VENMO_CLEARED = 'VENMO_CLEARED',
    PAYPAL_CLEARED = 'PAYPAL_CLEARED',
    ADJUSTMENT = 'ADJUSTMENT',
    INTEREST_PAYMENT = 'INTEREST_PAYMENT',
    BUY_INVESTMENT = 'BUY_INVESTMENT',
    SELL_INVESTMENT = 'SELL_INVESTMENT',
    BUY_INVESTMENT_CLEARED = 'BUY_INVESTMENT_CLEARED',
    SELL_INVESTMENT_CLEARED = 'SELL_INVESTMENT_CLEARED',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    LOCKBOX_PAYMENT = 'LOCKBOX_PAYMENT',
    PAYMENT_CARD_RETURN = 'PAYMENT_CARD_RETURN',
    ROLLOVER = 'ROLLOVER',
    DIGITAL_SETTLEMENT = 'DIGITAL_SETTLEMENT',
    DEBIT_VENMO_PAYPAL_REJECTED = 'DEBIT_VENMO_PAYPAL_REJECTED',
    RETURN_REPLENISHMENT_PAYMENT = 'RETURN_REPLENISHMENT_PAYMENT',
    RECORD_KEEPING = 'RECORD_KEEPING',
    CONTRIBUTION_PAID = 'CONTRIBUTION_PAID',
    PREFUND_REPLENISHMENT = 'PREFUND_REPLENISHMENT',
    INTERNAL_TRANSFER_OF_ASSETS = 'INTERNAL_TRANSFER_OF_ASSETS',
    HSA_INCOMING_CONTRIBUTION = 'HSA_INCOMING_CONTRIBUTION',
    HSA_ROLLOVER = 'HSA_ROLLOVER',
    ORPHAN_EE_FEE = 'ORPHAN_EE_FEE',
    ORPHAN_EE_FEE_PAYMENT = 'ORPHAN_EE_FEE_PAYMENT',
    ADMIN_FEE = 'ADMIN_FEE',
    ADMIN_FEE_PAYMENT = 'ADMIN_FEE_PAYMENT',
    REPLENISHMENT_REVERSE = 'REPLENISHMENT_REVERSE',
    ACH_REJECTED = 'ACH_REJECTED',
    RETURN_CONTRIBUTION_PAYMENT = 'RETURN_CONTRIBUTION_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_REVERSE = 'HSA_INCOMING_CONTRIBUTION_REVERSE',
    HSA_ROLLOVER_REVERSE = 'HSA_ROLLOVER_REVERSE',
    INVESTMENT_FEES = 'INVESTMENT_FEES',
    REPLENISHMENT_FUNDING_REVERSE = 'REPLENISHMENT_FUNDING_REVERSE',
    RETURN_REPLENISHMENT_FUNDING_PAYMENT = 'RETURN_REPLENISHMENT_FUNDING_PAYMENT',
    CLAIM_TRANSFER = 'CLAIM_TRANSFER',
    CLAIM_TRANSFER_INTERNAL = 'CLAIM_TRANSFER_INTERNAL',
    PAYROLL_REVERSE = 'PAYROLL_REVERSE',
    CONTRIBUTION_PAID_REVERSE = 'CONTRIBUTION_PAID_REVERSE',
    CONTRIBUTION_REVERSE_PAYMENT = 'CONTRIBUTION_REVERSE_PAYMENT',
    PREFUND_REPLENISHMENT_RETURN = 'PREFUND_REPLENISHMENT_RETURN',
    FINAL_PREFUND_REPLENISHMENT_RETURN = 'FINAL_PREFUND_REPLENISHMENT_RETURN',
    PREFUND_PAYMENT = 'PREFUND_PAYMENT',
    PREFUND_INTER = 'PREFUND_INTER',
    RETURN_PREFUND_FUNDING_PAYMENT = 'RETURN_PREFUND_FUNDING_PAYMENT',
    PREFUND_FINAL = 'PREFUND_FINAL',
    PREFUND_FUNDING_REVERSE = 'PREFUND_FUNDING_REVERSE',
    RETURN_LOCKBOX = 'RETURN_LOCKBOX',
    INBOUND_CHECK_CLEARED = 'INBOUND_CHECK_CLEARED',
    LOCKBOX_INCOMING = 'LOCKBOX_INCOMING',
    INBOUND_TRANSFER_OF_ASSETS = 'INBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_TRANSFER_OF_ASSETS = 'OUTBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_CHECK_CLEARED = 'OUTBOUND_CHECK_CLEARED',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    WRITE_OFF = 'WRITE_OFF',
    FORFEITURE = 'FORFEITURE',
    PUSH_REPLENISHMENT_PAYMENT = 'PUSH_REPLENISHMENT_PAYMENT',
    PUSH_PREFUND_PAYMENT = 'PUSH_PREFUND_PAYMENT',
    PUSH_CONTRIBUTION_PAYMENT = 'PUSH_CONTRIBUTION_PAYMENT',
    PAYMENT_EE_FEE = 'PAYMENT_EE_FEE',
    ACCOUNT_MAINTENANCE_EE_FEE = 'ACCOUNT_MAINTENANCE_EE_FEE',
    PAPER_STATEMENT_EE_FEE = 'PAPER_STATEMENT_EE_FEE',
    EE_FEES_BULK_PAYMENT = 'EE_FEES_BULK_PAYMENT',
    OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS = 'OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS',
    FEE_TRANSFER_INTERNAL = 'FEE_TRANSFER_INTERNAL',
    FEE_TRANSFER = 'FEE_TRANSFER',
    CLAIM_REJECTION = 'CLAIM_REJECTION',
    ACH_CLAIM_REPAYMENT = 'ACH_CLAIM_REPAYMENT',
    ACH_CLAIM_REPAYMENT_REJECTED = 'ACH_CLAIM_REPAYMENT_REJECTED',
    CLAIM_REPAYMENT_REJECTION = 'CLAIM_REPAYMENT_REJECTION',
    CLAIM_REPAYMENT_TRANSFER_INTERNAL = 'CLAIM_REPAYMENT_TRANSFER_INTERNAL',
    CLAIM_REPAYMENT_TRANSFER = 'CLAIM_REPAYMENT_TRANSFER',
    LOCKBOX_CHECK_CLEARED = 'LOCKBOX_CHECK_CLEARED',
    LOCKBOX_CLAIM_REPAYMENT = 'LOCKBOX_CLAIM_REPAYMENT',
    NOTIONAL_CONTRIBUTION_PAID = 'NOTIONAL_CONTRIBUTION_PAID',
    PREFUND_RETURN_PAYMENT_REVERSE = 'PREFUND_RETURN_PAYMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT = 'CLAIM_BALANCE_ADJUSTMENT',
    NOTIONAL_CONTRIBUTION_PAID_REVERSE = 'NOTIONAL_CONTRIBUTION_PAID_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT = 'ROLLOVER_BALANCE_ADJUSTMENT',
    EOY_PLAN_FUNDS_INTERNAL_RETURN = 'EOY_PLAN_FUNDS_INTERNAL_RETURN',
    PUSH_RETURN_PAYMENT = 'PUSH_RETURN_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_PAYMENT = 'HSA_INCOMING_CONTRIBUTION_PAYMENT',
    NOTIONAL_PAYROLL_REVERSE = 'NOTIONAL_PAYROLL_REVERSE',
    EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION = 'EOY_PLAN_SHORTAGE_COLLECTION',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT',
    PUSH_UNKNOWN_PAYMENT = 'PUSH_UNKNOWN_PAYMENT',
    UNMATCHED_PUSH_KEEPING = 'UNMATCHED_PUSH_KEEPING',
    PUSH_INVOICE_PAYMENT = 'PUSH_INVOICE_PAYMENT',
    UNMATCHED_PUSH_RETURN = 'UNMATCHED_PUSH_RETURN',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL',
    ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS = 'ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL',
    BULK_BALANCE_ADJUSTMENT = 'BULK_BALANCE_ADJUSTMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE',
    BULK_BALANCE_ADJUSTMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE'
}


/**
 * Check if a given object implements the ITransactionDto interface.
 */
export function instanceOfITransactionDto(value: object): value is ITransactionDto {
    return true;
}

export function ITransactionDtoFromJSON(json: any): ITransactionDto {
    return ITransactionDtoFromJSONTyped(json, false);
}

export function ITransactionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITransactionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'postings': json['postings'] == null ? undefined : (new Set((json['postings'] as Array<any>).map(IPostingDtoFromJSON))),
        'tags': json['tags'] == null ? undefined : (new Set((json['tags'] as Array<any>).map(ITransactionTagDtoFromJSON))),
        'force': json['force'] == null ? undefined : json['force'],
        'type': json['type'] == null ? undefined : json['type'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'transaction_at': json['transaction_at'] == null ? undefined : (new Date(json['transaction_at'])),
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'ignore_account_status_validation': json['ignore_account_status_validation'] == null ? undefined : json['ignore_account_status_validation'],
        'workflow_id': json['workflow_id'] == null ? undefined : json['workflow_id'],
    };
}

export function ITransactionDtoToJSON(json: any): ITransactionDto {
    return ITransactionDtoToJSONTyped(json, false);
}

export function ITransactionDtoToJSONTyped(value?: ITransactionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'memo': value['memo'],
        'postings': value['postings'] == null ? undefined : (Array.from(value['postings'] as Set<any>).map(IPostingDtoToJSON)),
        'tags': value['tags'] == null ? undefined : (Array.from(value['tags'] as Set<any>).map(ITransactionTagDtoToJSON)),
        'force': value['force'],
        'type': value['type'],
        'metadata': value['metadata'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'transaction_at': value['transaction_at'] == null ? undefined : ((value['transaction_at']).toISOString()),
        'external_identifier': value['external_identifier'],
        'ignore_account_status_validation': value['ignore_account_status_validation'],
        'workflow_id': value['workflow_id'],
    };
}

